import { AccountBadgeContext } from '../../../../../ui/features/badge-management/contexts/AccountBadgeContext';
import { useAccountBadgeBulkActions } from '../../../../../ui/features/badge-management/hooks/useAccountBadgeBulkActions';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import AddIcon from '@mui/icons-material/Add';
import BlockIcon from '@mui/icons-material/Block';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import SendIcon from '@mui/icons-material/Send';
import React from 'react';
import { useAccountBadgeTable } from '../../hooks/useAccountBadgeTable';
import { AccountBadgeSlideout } from '../AccountBadgeSlideout/AccountBadgeSlideout';
export const AccountBadgeTable = ({ badgeId, accountBadges, refetchBadgeDetails }) => {
    var _a, _b, _c, _d, _e;
    const { t } = useBadgingTranslation();
    const { dataTableProps, reload, clearActiveRow } = useAccountBadgeTable({
        initialFilter: [
            {
                op: '=',
                column: 'badgeId',
                value: badgeId,
            },
        ],
    });
    const appliedStorageFilters = (_c = (_b = (_a = dataTableProps.customBackendResponseData) === null || _a === void 0 ? void 0 : _a.storageClientRequest) === null || _b === void 0 ? void 0 : _b.filter) !== null && _c !== void 0 ? _c : [];
    const reloadAccountBadgeData = React.useCallback(() => {
        void refetchBadgeDetails();
        reload();
    }, [refetchBadgeDetails, reload]);
    const bulkActions = useAccountBadgeBulkActions({
        badgeId,
        accountBadgesAll: accountBadges,
        accountBadgeRows: dataTableProps.rows,
        accountBadgeSelectedIds: (_d = dataTableProps.selectedRowIds) !== null && _d !== void 0 ? _d : [],
        onActionCompleted: reloadAccountBadgeData,
        appliedStorageFilters,
        filteredRowCount: dataTableProps.filteredRowCount,
    });
    const { buildAccountBadgeSlideoutComponent } = React.useContext(AccountBadgeContext);
    const AccountBadgeSlideoutImpl = buildAccountBadgeSlideoutComponent === null || buildAccountBadgeSlideoutComponent === void 0 ? void 0 : buildAccountBadgeSlideoutComponent(AccountBadgeSlideout);
    return (React.createElement(React.Fragment, null,
        React.createElement(DataTable, Object.assign({}, dataTableProps, { globalActions: [
                {
                    icon: React.createElement(AddIcon, null),
                    label: t('badges.badgeDetails.accountBadgeTable.actions.addAccount'),
                    disabled: !bulkActions.canAddAccount,
                    onClick: bulkActions.handleAddAccount,
                },
            ], localActions: [
                {
                    icon: React.createElement(SendIcon, null),
                    label: t('badges.badgeDetails.accountBadgeTable.actions.notify'),
                    onClick: bulkActions.handleNotify,
                },
                {
                    icon: React.createElement(PrintOutlinedIcon, null),
                    label: t('badges.badgeDetails.accountBadgeTable.actions.print'),
                    onClick: bulkActions.handlePrintAccountBadges,
                },
                {
                    icon: React.createElement(BlockIcon, null),
                    label: t('badges.badgeDetails.accountBadgeTable.actions.revoke'),
                    onClick: bulkActions.handleRevoke,
                },
                {
                    icon: React.createElement(PublishedWithChangesIcon, null),
                    label: t('badges.badgeDetails.accountBadgeTable.actions.changeDistribution'),
                    onClick: bulkActions.handleChangeDistributionStatus,
                },
                {
                    icon: React.createElement(PrintOutlinedIcon, null),
                    label: t('badges.badgeDetails.accountBadgeTable.actions.reissue'),
                    onClick: bulkActions.handleReissueAccountBadgesBulkActionDialog,
                },
            ] })),
        AccountBadgeSlideoutImpl && (React.createElement(AccountBadgeSlideoutImpl, { accountBadgeId: (_e = dataTableProps.activeRowId) !== null && _e !== void 0 ? _e : '', refetchAccountBadgeList: reloadAccountBadgeData, onClose: (changed) => {
                clearActiveRow();
                if (changed) {
                    reloadAccountBadgeData();
                }
            } }))));
};
